import { render } from "./TranscoderSources.vue?vue&type=template&id=3cbef2f9"
import script from "./TranscoderSources.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscoderSources.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Transcoder/TranscoderSources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cbef2f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cbef2f9', __exports__)) {
    api.reload('3cbef2f9', __exports__)
  }
  
  module.hot.accept("./TranscoderSources.vue?vue&type=template&id=3cbef2f9", () => {
    api.rerender('3cbef2f9', render)
  })

}


export default __exports__